<div *ngIf="contactInfo && contactInfo.primaryEmail?.length > 0">
  <div>
    <div class="access-codes my-2" style="text-align:center;padding:10px;">
      <adp-label *ngIf="!isSPOEEnabled" labelKey="LookupUser_ReviewContact_Text_ConfirmInstruction"></adp-label>
      <adp-label *ngIf="isSPOEEnabled" labelKey="SPOE_LookupUser_ReviewContact_Text_ConfirmInstruction"></adp-label>
    </div>
    <div class="col-12 px-0">
      <form [formGroup]="userForm" style="height: 200px;">
        <div class="row userForm">
          <div class="col-12">
            <adp-input class="w-100" formControlName="firstName"
              [resourceData]="firstNameResourceData" ></adp-input>
          </div>
        </div>
        <div class="row userForm">
          <div class="col-12">
            <adp-input class="w-100" formControlName="lastName"
              [resourceData]="lastNameResourceData"></adp-input>
          </div>
        </div>
      </form>
      <form class="form" [formGroup]="contactForm">
        <div fxLayout="row" class="row-item">
          <div fxLayout="column" class="label-text emailForm" [ngClass]="{'contact-container': !emailEdit}">
            <adp-label labelKey="LookupUser_ReviewContact_Text_Email_Address" class="fw-600"></adp-label>
            <div *ngIf="!emailEdit" style="word-wrap:break-word;">{{contactInfo.primaryEmail}}</div>
            <div *ngIf="!emailEdit">
              <span *ngIf="policyEmailExists">
               <mat-error class="text-danger"><adp-label labelKey="Global_Error_Code_OktaUserAlreadyExist"></adp-label></mat-error>
              </span>
            </div>
            <div class="full-width text-field" *ngIf="emailEdit">
              <adp-input pgh-autofocus [resourceData]="getResource('EmailAddress_Field')" formControlName="email"
                class="w-100" (blur)="onBlurEmailField()" [hideValidationMessage]="false">
              </adp-input>
              <mat-error *ngIf="emailError" class="text-danger">{{emailError}}</mat-error>
            </div>
          </div>
          <a *ngIf="!emailEdit" href="javascript:void(0);" (click)="emailEdit = !emailEdit;" class="edit-button" fxLayout="row">
            <mat-icon [class]="'adp-ds-icon-wrapper'" svgIcon="edit"></mat-icon>
            <div class="ml-5">EDIT</div>
          </a>
        </div>
        <div fxLayout="row" class="row-item" *ngIf="!isSPOEEnabled">
          <div fxLayout="column" class="label-text">
            <adp-label labelKey="LookupUser_ReviewContact_Text_Mobile_Number" class="fw-600"></adp-label>
            <div *ngIf="!phoneEdit && !!maskedPhoneNumber">{{maskedPhoneNumber}}</div>
            <div class="full-width text-field" *ngIf="phoneEdit || !contactInfo.phone">
              <adp-input pgh-autofocus [resourceData]="getResource('MobileNumber_Field')" formControlName="phone"
                class="w-100" (blur)="onBlurPhoneField()" [hideValidationMessage]="false">
              </adp-input>
              <mat-error *ngIf="phoneError" class="text-danger">{{phoneError}}</mat-error>
            </div>
          </div>
          <a *ngIf="!phoneEdit && !!contactInfo.phone" href="javascript:void(0);" (click)="phoneEdit = !phoneEdit;" class="edit-button" fxLayout="row">
            <mat-icon [class]="'adp-ds-icon-wrapper'" svgIcon="edit"></mat-icon>
            <div class="ml-5">EDIT</div>
          </a>
        </div>
      </form>
      <div class="form-group mt-4 mb-3">
        <button mat-flat-button class="next-btn" color="accent" (click)="confirm()" [disabled]="!contactForm.valid || !!emailError || !!phoneError || !userForm.valid">
          <adp-label labelKey="Global_Button_Confirm"></adp-label>
        </button>
      </div>
    </div>
  </div>
</div>
